/**
 * Nuxt Image Gumlet provider — see `~/utils/gumletUtils` (`gumletEnabled` gate).
 */
import { gumletImageUrlOrOriginal } from '~/utils/gumletUtils'

export const getImage = (
  src: string,
  options: { modifiers?: Record<string, unknown> } = {},
  _ctx: unknown
) => {
  const config = useRuntimeConfig()
  const url = gumletImageUrlOrOriginal(src, options.modifiers ?? {}, config)
  return { url, fallback: src, _originalUrl: src }
}
